import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { PmsValueType } from 'lumen/utils/central-mapping-constants';

export default class CentralMappingPmsValueType extends Model {
  [Type] = 'central-mapping/pms-value-type' as const;

  @attr('boolean') declare available: boolean;
  @attr('string') declare valueType: PmsValueType;
}
